export class ConfirmPlayerReadyRequest {
    static Message = 'ConfirmPlayerReadyRequest';
}

export class ConfirmPlayerReadyResponse {
    static Message = 'ConfirmPlayerReadyResponse';

    public playerId: string;

    constructor(playerId: string) {
        this.playerId = playerId;
    }
}
